import { combinePath } from '../../dataConnections/dataConnection.utils';
import {
    makeXPathEngineFromNamespaces,
    parseXmlNative,
} from '../../utility/xmlHelpers';
import { getNodeValue } from '../../xmlUtility';
import { selectNodeFromXPathEngine } from '../qRules/helpers/qRules.utility';
import {
    CONNECTION_TYPE_ADO,
    CONNECTION_TYPE_SHPLIST,
    CONNECTION_TYPE_WEBSERVICE,
    elementNameToType,
} from './dataConnection.types';

const parseXML = parseXmlNative;

const createXPathEngine = () =>
    makeXPathEngineFromNamespaces({
        udc: 'http://schemas.microsoft.com/office/infopath/2006/udc',
        m: 'http://schemas.microsoft.com/ado/2007/08/dataservices/metadata',
    });

const connectionPath = '/*/udc:ConnectionInfo/';
const selectCommandPath = 'udc:SelectCommand/';
const updateCommandPath = 'udc:UpdateCommand/';

function udcxFileAdapter(definition, makeAdapter, template, shpAccess) {
    const source = definition.source;
    const sc = definition.siteCollection;

    let me = null;

    function parseNodeValue(xpathEngine, basePath, xmlNode, nodeName) {
        const nodeElement = selectNodeFromXPathEngine(
            xpathEngine,
            `${basePath}udc:${nodeName}`,
            xmlNode,
        );

        return nodeElement ? getNodeValue(nodeElement) : '';
    }

    function assignAdoAdapterProperties(xpathEngine, xmlNode) {
        const basePath = connectionPath + selectCommandPath;

        definition.commandText = parseNodeValue(
            xpathEngine,
            basePath,
            xmlNode,
            'Query',
        );
        definition.connectionString = parseNodeValue(
            xpathEngine,
            basePath,
            xmlNode,
            'ConnectionString',
        );
    }

    function assignSharePointProperties(xpathEngine, xmlNode) {
        const basePath = connectionPath + selectCommandPath;
        const listIdNode = selectNodeFromXPathEngine(
            xpathEngine,
            basePath + 'udc:ListId',
            xmlNode,
        );
        const webUrlNode = selectNodeFromXPathEngine(
            xpathEngine,
            basePath + 'udc:WebUrl',
            xmlNode,
        );
        const listId = listIdNode ? getNodeValue(listIdNode) : '';
        const webUrl = webUrlNode ? getNodeValue(webUrlNode) : '';

        definition.listId = listId;
        definition.siteURL = webUrl;

        //TODO:Assign relListUrl ?
    }

    function getNodeProperty(xpathEngine, xmlNode, nodeName) {
        var selectBasePath = connectionPath + selectCommandPath,
            updateBasePath = connectionPath + updateCommandPath;

        var nodeValue = parseNodeValue(
            xpathEngine,
            selectBasePath,
            xmlNode,
            nodeName,
        );
        if (nodeValue !== '') {
            return nodeValue;
        }

        return parseNodeValue(xpathEngine, updateBasePath, xmlNode, nodeName);
    }

    function assignWebProperties(xpathEngine, xmlNode) {
        definition.wsdlUrl = parseNodeValue(
            xpathEngine,
            connectionPath,
            xmlNode,
            'WsdlUrl',
        );
        definition.serviceUrl = getNodeProperty(
            xpathEngine,
            xmlNode,
            'ServiceUrl',
        );
        definition.soapAction = getNodeProperty(
            xpathEngine,
            xmlNode,
            'SoapAction',
        );

        //TODO:Assign methodName ?
    }

    function assignAdapterProperties(adapterType, xpathEngine, xmlNode) {
        switch (adapterType) {
            case CONNECTION_TYPE_ADO:
                assignAdoAdapterProperties(xpathEngine, xmlNode);
                return;
            case CONNECTION_TYPE_SHPLIST:
                assignSharePointProperties(xpathEngine, xmlNode);
                return;
            case CONNECTION_TYPE_WEBSERVICE:
                assignWebProperties(xpathEngine, xmlNode);
                return;
            default:
                return;
        }
    }

    function getUdcxPath() {
        return combinePath(template.getBasePath(), sc + source);
    }

    function parseUdcxContents(xmlData) {
        const xmlNode = parseXML(xmlData);
        const xpathEngine = createXPathEngine();
        const adapterType = elementNameToType(definition.localName);

        assignAdapterProperties(adapterType, xpathEngine, xmlNode);

        definition.type = adapterType;
    }

    function makeUdcxInitFailureError(err, udcxPath) {
        const newError = new Error(
            'Could not access the UDCX file at ' + udcxPath,
        );
        newError.description = err.message;

        return newError;
    }

    const tryGetUdcx = async () => {
        const udcxPath = getUdcxPath();

        try {
            return await shpAccess.queryXmlAsync(udcxPath);
        } catch (e) {
            throw makeUdcxInitFailureError(e, udcxPath);
        }
    };

    const initAsync = async (dataSource) => {
        const udcxXml = await tryGetUdcx();

        parseUdcxContents(udcxXml);

        const adapter = makeAdapter(definition);

        if (adapter && adapter.initAsync) {
            await adapter.initAsync(dataSource);
        }

        // assume the identity of the adapter
        Object.assign(me, adapter);
    };

    me = {
        initAsync,
    };

    return me;
}

export default udcxFileAdapter;
